import { useEffect, useState } from 'react';
import './AuditioneeViewer.css';
import Loader from '../../_media/loaders/loader.gif';
import SectionLoader from '../../_shoru_shared_library/loaders/SectionLoader';


import Direct from '../../_media/clashbot/direct_clash.svg';
import Potential from '../../_media/clashbot/potential_clash.svg';
import Ghost from '../../_media/clashbot/ghost_clash.svg';
import NoClash from '../../_media/clashbot/no_clash.svg';
import { Clear } from '@mui/icons-material';


export function AuditioneeViewer({index, auditionees, data, register, setSelected}) {

  const [direct, setDirect] = useState(null);
  const [potential, setPotential] = useState(null);
  const [ghost, setGhost] = useState(null);

  // There are two kinds of roles not featured in the register:
  // Cast Roles - roles that have already had their outcome decided (these are hidden from the register)
  // Deep Roles - instances where the auditionee is third choice or later (these are not used by the register)
  const [cast, setCast] = useState(null);
  const [deep, setDeep] = useState(null);

  const auditionee = auditionees[index];


  // Extract direct, potential, and ghost clashes (if applicable)
  useEffect(() => {
    let direct = [];
    let potential = [];
    let ghost = [];
    register.every((r) => {
      if(r.auditionee_id === index) {
        direct = [...r.current_choices];
        potential = [...r.potential_clashes];
        ghost = [...r.ghost_clashes];
        return false;
      }
      return true;
    })
    setDirect(direct);
    setPotential(potential);
    setGhost(ghost);
  }, [index, register])

  // Find cast and deep roles
  useEffect(() => {
    const otherRoles = _findOtherRoles(index, data, auditionee);
    setCast(otherRoles.cast);
    setDeep(otherRoles.deep);
  }, [index, data])


  return (
    <div className='auditionee-viewer-container' onClick={() => setSelected(null)}>
      <div className='auditionee-viewer' onClick={(e) => e.stopPropagation()}>
        <div onClick={() => setSelected(null)} className='auditionee-x'>
          <Clear />
        </div>

        <p className='auditionee-label'>AUDITIONEE</p>
        <h2>{auditionee.names[0]}</h2>
        <div className='auditionee-details-table'>
          <p className='auditionee-details-header'>Name</p>
          <p className='auditionee-details-header'>Email</p>
          <p className='auditionee-details-header'>Phone Number</p>
          <div style={{display: 'flex', flexDirection: 'column'}}>
            { auditionee.names.map((n, i) => <p key={i} className='auditionee-details-entry'>{n}</p>) }
          </div>
          <div style={{display: 'flex', flexDirection: 'column'}}>
            { auditionee.emails.map((e, i) => <p key={i} className='auditionee-details-entry'>{e}</p>) }
          </div>
          <div style={{display: 'flex', flexDirection: 'column'}}>
            { auditionee.phones.map((p, i) => <p key={i} className='auditionee-details-entry'>{p}</p>) }
          </div>
        </div>

        {
          (direct && potential && ghost && cast && deep) 

          ? <div>
              {
                cast.length 
                ? 
                <div>
                  <p style={{marginBottom: '8px'}} className='auditionee-viewer-header'>Cast As</p>
                  <HighlightBoxes entries={cast} data={data} colour='#6ab04c' />
                </div>
                : null
              }
              {
                (direct.length || potential.length || ghost.length || deep.length) 
                ? 
                <div>
                  <p className='auditionee-viewer-header'>Remaining Positions</p>
                  <p className='auditionee-viewer-description'>You can switch to a different auditionee by clicking their name below</p>
                  <RoleTable 
                    entries={[
                      ...direct,
                      ...potential,
                      ...ghost,
                      ...deep
                    ]} 
                    index={index} 
                    auditionees={auditionees} 
                    data={data} 
                    register={register}
                    setSelected={setSelected}
                  />
                </div>
                : <p className='auditionee-viewer-header'>{auditionee.names[0]} is not in the running for any more roles</p>
              }
            </div>

          : <div style={{width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '20px', marginBottom: '20px'}}>
              <img src={Loader} width='100px' style={{filter:'saturate(0)'}} />
            </div>
        }

      </div>
    </div>
  )

}


function _findOtherRoles(index, data, auditionee) {

  let cast = [];
  let deep = [];

  data.forEach((p, pi) => {
    p.roles.forEach((r, ri) => {

      const item = {project_index: pi, role_index: ri}

      // Check 'cast' condition
      if(r.cast) {
        if(r.choices[0] === index) {
          cast.push(item);
        }
      }
      else if([r.choices[1], r.choices[2], r.choices[3], r.choices[4]].includes(index)) {
        deep.push(item);
      }
    })
  })

  return {cast: cast, deep: deep};

}


function HighlightBoxes({entries, data, colour}) {
  return (
    <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px'}}>
    { 
      entries.map((e, i) => {
        return (
          <div key={`${e.project_index}-${e.role_index}-${i}`} className='auditionee-cast-box' style={{border: `1px solid ${colour}`, backgroundColor: `${colour}aa`}}>
            <p>{data[e.project_index].roles[e.role_index].name}</p>
            <p className='auditionee-cast-box-detail'>{data[e.project_index].name}</p>
            <p className='auditionee-cast-box-detail'>Week {data[e.project_index].week} {data[e.project_index].project_type}</p>
          </div>
        )
      })
    }
    </div>
  )
}


function RoleTable({entries, index, auditionees, data, register, setSelected}) {

  let positions = [];

  const setEntries = entries.filter(
    (item, index, self) =>
      index === self.findIndex(
        t => t.project_index === item.project_index && t.role_index === item.role_index
      )
  );

  setEntries.forEach((e) => {

    const roleAndProd = (
      <div key={`${e.project_index}-${e.role_index}-h`} style={{borderRight: '1px solid #555'}} className='auditionee-role-cell'>
        <div>
          <b>{data[e.project_index].roles[e.role_index].name}</b>
        </div>
        <div>
          <i>{data[e.project_index].name}</i>
        </div>
      </div>
    )
    positions.push(roleAndProd);

    let imgSrc = null;
    const choices = data[e.project_index].roles[e.role_index].choices;

    choices.forEach((c, i) => {
      if(c === null) positions.push(<div key={`empty-${e.project_index}-${e.role_index}-${i}`} className='auditionee-role-cell' />);
      else {
        const selected = (c === index);
        const registerEntry = getRegisterEntry(c, register);

        // Determine text colour
        let colour = '#c0c0c0';
        if(registerEntry) {
          if (i === 0) {
            colour = '#66a84a'
            if(registerEntry.current_choices.length > 1) {
              colour = '#d63031';
              if(selected) imgSrc = Direct;
            }
            else if(registerEntry.potential_clash) {
              colour = '#f0932b';
              if(selected) imgSrc = Potential;
            }
            else if(selected) imgSrc = NoClash;
          }
          else if (i === 1) {
            if(hasEntry(registerEntry.potential_clashes, e)) {
              colour = '#f0932b';
              if(selected) imgSrc = Potential;
            }
            else if(hasEntry(registerEntry.ghost_clashes, e)) {
              colour = '#22a6b3';
              if(selected) imgSrc = Ghost;
            }
          }
        }

        const name = auditionees[c].names[0];
        positions.push(
          <div 
            key={`${c}-${e.project_index}-${e.role_index}-${i}`} 
            onClick={() => {if(!selected) setSelected(c)}} 
            className={`auditionee-name-cell ${!selected ? 'auditionee-selectable-cell' : ''}`} 
            style={{color: colour}} 
          >
            {name}
          </div>
        )
      }
    })

    const badgeItem = (
      <div key={`badge-${e.project_index}-${e.role_index}`} className='auditionee-badge-cell'>
        {
          imgSrc 
          ? <img width='28px' src={imgSrc} />
          : <div style={{width: '28px', height: '28px'}} />
        }
      </div>
    );
    positions.splice(positions.length-6, 0, badgeItem)

  })

  return (
    <div className='auditionee-role-table'>
      <div className='auditionee-role-header'/>
      <p className='auditionee-role-header'>Role / Production</p>
      <p className='auditionee-role-header'>1</p>
      <p className='auditionee-role-header'>2</p>
      <p className='auditionee-role-header'>3</p>
      <p className='auditionee-role-header'>4</p>
      <p className='auditionee-role-header'>5</p>
      {positions}
    </div>
  )

}


function getRegisterEntry(auditioneeId, register) {
  return register.find((r) => {
    return r.auditionee_id === auditioneeId;
  }) || null;
}


function hasEntry(registerSet, entry) {
  return registerSet.find((r) => {
    return (
      r.project_index === entry.project_index &&
      r.role_index === entry.role_index
    );
  }) || false;
}